import React from 'react';
import { Button } from 'primereact/button';
import { dictionary } from '../../../dictionary';

const ModuleTypesComponent = ({ resetCountryButtons, dispatch, setModType, setModule, clearTask, isEspDialog}) => {
  return (
    <>
      <div className="col">
        <Button
          className="buttons"
          label={dictionary.dialog_button_label7}
          onClick={() => {
            resetCountryButtons(dispatch);
            dispatch(setModType('FtF'));
            dispatch(clearTask());
          }}
        />
        <Button
          className="buttons"
          label={dictionary.dialog_button_label1}
          onClick={() => {
            resetCountryButtons(dispatch);
            dispatch(setModType('FtF_2.0'));
            dispatch(clearTask());
          }}
        />
        <Button
          className="buttons"
          label={dictionary.dialog_button_label8}
          onClick={() => {
            resetCountryButtons(dispatch);
            dispatch(setModType('Logistics'));
            dispatch(clearTask());
          }}
        />
        <Button
          className="buttons"
          label={dictionary.dialog_button_label9}
          onClick={() => {
            resetCountryButtons(dispatch);
            dispatch(setModType('MA'));
            dispatch(clearTask());
          }}
        />
        <Button
          className="buttons"
          label={dictionary.dialog_button_label10}
          onClick={() => {
            resetCountryButtons(dispatch);
            dispatch(setModType('MA_2.0'));
            dispatch(clearTask());
          }}
        />
      </div>
      <div className="col">
        <Button
          className="buttons"
          label={dictionary.dialog_button_label2}
          onClick={() => {
            resetCountryButtons(dispatch);
            dispatch(setModType('MA_3.0'));
            dispatch(clearTask());
          }}
        />
        <Button
          className="buttons"
          label={dictionary.dialog_button_label11}
          onClick={() => {
            resetCountryButtons(dispatch);
            dispatch(setModType('Nugget AUDI'));
            dispatch(clearTask());
          }}
        />
        <Button
          className="buttons"
          label={dictionary.dialog_button_label12}
          onClick={() => {
            resetCountryButtons(dispatch);
            dispatch(setModType('Nugget INT'));
            dispatch(clearTask());
          }}
        />
        <Button
          className="buttons"
          label={dictionary.dialog_button_label4}
          onClick={() => {
            resetCountryButtons(dispatch);
            dispatch(setModType('Other'));
            dispatch(clearTask());
          }}
        />
       {!isEspDialog && <Button
          className="buttons"
          label={dictionary.dialog_button_label13}
          onClick={() => {
            resetCountryButtons(dispatch);
            dispatch(setModule('Hour management'));
            dispatch(setModType('Hour management'));
            dispatch(clearTask());
          }}
        />}
      </div>
    </>
  );
};

export default ModuleTypesComponent;
